<template>
  <div class="salaries-content">
    <div id="recap" class="salaries-content__margin" />
    <SalariesContentGroupRecap class="salaries-content__group" />
    <SalariesContentDelimiter id="sdr-guide" :words="['sdr', 'guide']" />
    <SalariesContentGroupSdrGuide class="salaries-content__group" />
    <SalariesContentDelimiter id="ae-guide" :words="['ae', 'guide']" />
    <SalariesContentGroupAeGuide class="salaries-content__group" />
    <SalariesContentDelimiter id="trends" :words="['remote']" />
    <SalariesContentGroupTrends class="salaries-content__group" />
  </div>
</template>

<script>
import SalariesContentGroupRecap from './SalariesContentGroupRecap.vue';
import SalariesContentGroupSdrGuide from './SalariesContentGroupSdrGuide.vue';
import SalariesContentGroupAeGuide from './SalariesContentGroupAeGuide.vue';
import SalariesContentGroupTrends from './SalariesContentGroupTrends.vue';
import SalariesContentDelimiter from './SalariesContentDelimiter.vue';

export default {
  name: 'SalariesContent',
  components: {
    SalariesContentGroupRecap,
    SalariesContentGroupSdrGuide,
    SalariesContentGroupAeGuide,
    SalariesContentGroupTrends,
    SalariesContentDelimiter,
  },
};
</script>

<style lang="scss" scoped>
.salaries-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: url('./images/bg.svg');
  background-size: contain;

  &__margin {
    margin: 31px 0;

    @include mq('md') {
      margin: 80px 0;
    }

    @include mq('lg') {
      margin: 140px 0;
    }
  }

  &__group {
    width: 100vw;
    margin-bottom: 64px;

    @include mq('sm') {
      width: calc(100vw - 40px);
    }

    @include mq('md') {
      margin-bottom: 150px;
    }

    @include mq('lg') {
      width: 100%;
      max-width: 1260px;
      margin-bottom: 290px;
    }
  }
}
</style>
